<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-primary page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5 text-white"><i class="fa fa-cutlery"></i> Food Order </div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->

            

            <div class="row row-replace m-t-30 bg-white add-p-b10 justify-content-md-center">
                <div class="col-12 text-center">
                        <img src="assets/img/pantry/coffee.gif" class="food-title">
                </div>
                <div class="col-md-8 m-t-20">
                    <div class="row align-items-center b-b add-p-b10">
                        <div class="col-2 text-center" >S.No</div>
                        <div class="col-5">Items Align</div>
                        <div class="col-md-5 col-5 text-center">
                           Qty
                        </div>
                    </div>
               
                    <div class="row align-items-center" *ngFor="let items of mydata">
                        <div class="col-2 text-center" >{{items.item}}</div>
                        <div class="col-5"><img src={{items.icon}}> {{items.name}}</div>
                        <div class="col-md-5 col-5">
                            <div class="form-inline" style="justify-content: center;">
                            <button type="button" class="btn btn-sm btn-primary" (click)="decrement(items)"> - </button>
                            <input type="number" class="custom-input-num" [(ngModel)]="items.count">
                            <button type="button" class="btn btn-sm btn-primary" (click)="increment(items)"> + </button>
                            </div>
                        </div>
                    </div>
                
                    <!-- <div class="row align-items-center">
                        <div class="col-2 text-center" >2</div>
                        <div class="col-5"><img src="assets/img/pantry/salty.png"> Salry</div>
                        <div class="col-md-5 col-5">
                            <div class="form-inline" style="justify-content: center;">
                                <button type="button" class="btn btn-sm btn-primary" (click)="decrement()"> - </button>
                                <input type="number" class="custom-input-num" [value]="numb">
                                <button type="button" class="btn btn-sm btn-primary" (click)="increment()"> + </button>
                             </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-2 text-center" >3</div>
                        <div class="col-5"><img src="assets/img/pantry/coffee.png"> Coffee</div>
                        <div class="col-md-5 col-5">
                            <div class="form-inline" style="justify-content: center;">
                                <button type="button" class="btn btn-sm btn-primary" (click)="decrement()"> - </button>
                                <input type="number" class="custom-input-num" [value]="numb">
                                <button type="button" class="btn btn-sm btn-primary" (click)="increment()"> + </button>
                            </div>
                        </div>
                    </div>
                    <div class="row align-items-center">
                        <div class="col-2 text-center" >4</div>
                        <div class="col-5"><img src="assets/img/pantry/biscut.png"> Biscut</div>
                        <div class="col-md-5 col-5">
                            <div class="form-inline" style="justify-content: center;">
                                <button type="button" class="btn btn-sm btn-primary" (click)="decrement()"> - </button>
                                <input type="number" class="custom-input-num" [value]="numb">
                                <button type="button" class="btn btn-sm btn-primary" (click)="increment()"> + </button>
                            </div>
                        </div>
                    </div> -->
                    <hr>
                    <div class="row align-items-center">
                        <div class="col-md-2 col-3 m-t-10">Mobile:</div>
                        <div class="col-md-4 col-9 m-t-10"><input type="text" class="form-control"></div>
                        <div class="col-md-2 col-3 m-t-10">Name:</div>
                        <div class="col-md-4 col-9 m-t-10"><input type="text" class="form-control"></div>
                    </div>
                </div>

                   <div class="col-12 text-center add-p-tb">
                    <button class="btn btn-primary btn-sm">Order</button>
                </div>
            </div>

            
             
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

